import { render, staticRenderFns } from "./SfCarouselItem.vue?vue&type=template&id=751f7b20&"
import script from "./SfCarouselItem.vue?vue&type=script&lang=js&"
export * from "./SfCarouselItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports